/**
 * Magniberg newsletter sign-up (sections/mb-footer.liquid).
 *
 * Posts the form to Klaviyo's hosted subscribe endpoint (the form's `action`) without
 * leaving the page, then shows the success or error message. The fields are sent
 * form-encoded: `g` (the Klaviyo list id) and `email`.
 */
class MbNewsletter extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.addEventListener('submit', this.#onSubmit, { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @param {SubmitEvent} event */
  #onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();

    const message = this.querySelector('.mb-newsletter__message');
    form.setAttribute('aria-busy', 'true');

    let ok = false;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(/** @type {any} */ (new FormData(form))).toString(),
      });
      const result = await response.json();
      ok = result?.success === true;
    } catch {
      ok = false;
    }

    form.removeAttribute('aria-busy');

    if (message instanceof HTMLElement) {
      message.textContent = (ok ? message.dataset.success : message.dataset.error) ?? '';
      message.hidden = false;
    }

    if (ok) form.reset();
  };
}

if (!customElements.get('mb-newsletter')) {
  customElements.define('mb-newsletter', MbNewsletter);
}
